import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'apps/mba-cpr-survey-portal/src/environments/environment';
import { TableApiService } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tables/services/table-api.service';
import { IAudit } from '../interfaces/audit.interface';

@Injectable()
export class AuditTableService extends TableApiService<IAudit> {
  constructor(http: HttpClient) {
    super(http, `${environment.cprServiceApi}audit/`);
  }
}
